import React, { useContext } from "react";
import ApplicationContext from "../../context/ApplicationContext";
import { ILoginProps } from "./ILoginProps";
import { authenticate } from "../../services/Authenticate";
import { IAuth } from "../../types/IAuth";

import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  MessageHeader,
  Segment,
} from "semantic-ui-react";

export const Login: React.FC<ILoginProps> = (
  props: ILoginProps
): JSX.Element => {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const context = useContext(ApplicationContext);

  async function handleLogin() {
    setLoading(true);
    setError(false);

    var auth = await authenticate(username, password);

    if (!auth) {
      setLoading(false);
      setError(true);
      return;
    }

    const data: IAuth = auth.data;
    context.AuthenticatedUser.setUser(data.user);
    context.AuthenticatedUser.setToken(data.tokenValue);

    setError(false);
    setLoading(false);

    props.successful();
  }

  function onEnterHit(e: any) {
    if (e.key === "Enter") {
      handleLogin();
    }
  }

  const login = (): JSX.Element => (
    <Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header color="teal" textAlign="center" style={{ width: 350 }}>
          POSsible
        </Header>
        {error ? (
          <Message negative>
            <MessageHeader>Login failed</MessageHeader>
          </Message>
        ) : (
          <></>
        )}
        <Form size="large" onKeyUp={onEnterHit}>
          <Segment stacked>
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder="Username"
              onChange={(e) => setUsername(e.target.value)}
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              onChange={(e) => setPassword(e.target.value)}
            />

            {loading ? (
              <Button color="teal" fluid size="large" loading>
                Login
              </Button>
            ) : (
              <Button color="teal" fluid size="large" onClick={handleLogin}>
                Login
              </Button>
            )}
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  );

  return <>{login()}</>;
};
